/* eslint-disable */
require('./Arrive')
require('./arrow-right')
require('./bike-c')
require('./bike-colored')
require('./bike')
require('./booking')
require('./bus-c')
require('./bus-colored')
require('./bus-detailed')
require('./bus')
require('./calendar-checked')
require('./calendar')
require('./car-c')
require('./car-club-c')
require('./car-club-colored')
require('./car-club')
require('./car-colored')
require('./car-detailed')
require('./car')
require('./chevron-down')
require('./chevron-up')
require('./circle-question-mark')
require('./clock')
require('./community-transport-c')
require('./community-transport-colored')
require('./community-transport')
require('./dots')
require('./dotted-line-lg')
require('./dotted-line-small')
require('./dotted-line')
require('./dropdown')
require('./email')
require('./ferry-c')
require('./ferry-colored')
require('./ferry')
require('./fuse_logo')
require('./fuse')
require('./house')
require('./location')
require('./logo-full')
require('./phone')
require('./pricing')
require('./print')
require('./question-mark')
require('./sort')
require('./subway-c')
require('./subway-colored')
require('./subway')
require('./taxi-c')
require('./taxi-colored')
require('./taxi')
require('./three-dots')
require('./train-c')
require('./train-colored')
require('./train-detailed')
require('./train')
require('./tram-c')
require('./tram-colored')
require('./tram')
require('./walk-c')
require('./walk-colored')
require('./walk')
